import React, { useRef } from 'react';
import styled from 'styled-components';

const Card = styled.div`
  position: relative;
  border: 1px solid var(--border);
  background: var(--surface);
  border-radius: 20px;
  overflow: hidden;
  transition: border-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;

  /* mouse-following spotlight */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: radial-gradient(
      320px circle at var(--mx, 50%) var(--my, 0%),
      var(--spotlight),
      transparent 65%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }
  &:hover::before { opacity: 1; }

  &:hover {
    border-color: var(--border-strong);
    transform: translateY(-4px);
    box-shadow: var(--card-shadow);
  }
`;

const SpotlightCard = ({ children, className, onClick, as }) => {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--mx', `${e.clientX - rect.left}px`);
    el.style.setProperty('--my', `${e.clientY - rect.top}px`);
  };

  return (
    <Card ref={ref} as={as} className={className} onMouseMove={onMove} onClick={onClick}>
      {children}
    </Card>
  );
};

export default SpotlightCard;
